import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite';

import CollabWorkSpace from 'components/CollabWorkSpace';
import AssistantOnly from 'components/AssistantOnly';


const _CollabsRoute = observer(() => {
	const { collabKey = "" } = useParams<{ collabKey: string }>();
    return (
        <AssistantOnly allowClient={true}>
            <CollabWorkSpace collabKey={collabKey} />
        </AssistantOnly>
    );
});

export default _CollabsRoute;
